import { defineComponent as _defineComponent } from 'vue'
import { computed, useStore } from '@nuxtjs/composition-api';
import type { WarRoom } from '@/types/store/warRoom';
import type { RootState } from '~/types/store';

type WarRoomCommentPlaceholderProps = {
  comment?: WarRoom.State['commentTree'][number];
  post: WarRoom.CurrentPost;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomCommentPlaceholder',
  props: {
    comment: { default: () => ({}) },
    post: null
  },
  setup(__props: any) {

const props = __props as { comment: WarRoom.State['commentTree'][number], post: WarRoom.CurrentPost };


const store = useStore<RootState>();

const userDict = computed(() => store.state.warRoom.user_dict);
const publicUserDict = computed(() => store.state.warRoom.public_user_dict);

// In some cases we don't have username, quickfix is to hide comment if no username
// https://sentry.io/organizations/bravado-network/issues/3884962220/?environment=production&project=5952605&query=is%3Aunresolved&referrer=issue-stream
const user = computed(
  () => userDict.value[props.comment.user_username] || publicUserDict.value[props.comment.user_slug],
);
const achievement = computed(() => user.value?.achievements?.[0]?.title);

return { __sfc: true,props, store, userDict, publicUserDict, user, achievement }
}

})